import "@babel/polyfill";
import Vue from "vue";
import JsonExcel from 'vue-json-excel'
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./routes/router";
import store from "./store";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "./registerServiceWorker";
import { initMessaging } from "@/common/pushService";

Vue.config.productionTip = false;

initMessaging();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

Vue.component('downloadExcel', JsonExcel)